export default __webpack_public_path__ + "static/media/dark-legends-cover.94038db1.jpg";